// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"c7ccee7b","136":"9e5b528f","424":"84117cf2","592":"b59b40fc"}[chunkId] + ".chunk.js";
};